import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppProvider } from './lib/app-context';
import './styles.css';
import { captureReferral } from './lib/referral';
import { applyDocumentLanguage } from './lib/i18n';
import { registerServiceWorker } from './lib/push';

// lang and dir before the first paint, so Arabic never flashes left-to-right.
applyDocumentLanguage();

// A partner link can point at any page, so the code is read before routing.
captureReferral();

// Receives push notifications; registered early so a tap on one can open the site.
void registerServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
